export { default } from "./DocumentTitle";
